export { ClassificationGameCoreModule } from './classification-game-core.module';
export { ClassificationGameSelectorComponent } from './classification-game-selector/classification-game-selector.component';
export { ClassificationGameCoreService } from './classification-game-core.service';
export { IClassificationGame } from './classification-game.interface';
